module.exports = __webpack_public_path__ + "static/media/bckbck-light.350196e7.svg";